// Typing the name is the signature; it must match the legal name on file so a
// typo does not leave a document signed by nobody. Shared, so the brand portal
// can hold its button until the Worker would accept the name.
export function signatureMatches(fullName: string, signature: string): boolean {
  const normalise = (value: string) => String(value || '').normalize('NFKC').replace(/\s+/g, ' ').trim().toLowerCase();
  return Boolean(fullName) && normalise(fullName) === normalise(signature);
}
